import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import NumberFormat from "react-number-format";
import _ from "lodash";
import ReactTooltip from "react-tooltip";
import { connect, useSelector } from "react-redux";
import dashboardAction from "../../dashboard/actions";
import { BuildingStatistics } from "./BuildingStatistics";
import { DEFAULT_CAPITAL_REQUEST_LABEL, getCapitalRequestLabel } from "../../../utils/capitalRequestLabel";
import { BuildingBreakdown } from "./BuildingBreakdown";
import "./SidePanel.css";
import { checkPermission } from "../../../config/utils";
const SidePanel = props => {
    const buttonRef1 = useRef(null);
    const collapseRef1 = useRef(null);
    const buttonRef2 = useRef(null);
    const collapseRef2 = useRef(null);
    const { dashboardResetFlag, getDashboard } = useSelector(state => state.dashboardReducer);
    const miscellaneous = useSelector(state => state.projectReducer?.getProjectByIdResponse?.miscellaneous);
    const capitalRequestLabel =
        getDashboard?.side_panel?.project_ids?.length === 1 ? getCapitalRequestLabel(miscellaneous) : DEFAULT_CAPITAL_REQUEST_LABEL;
    const [statExpanded, setStatExpanded] = useState(true);
    const [activePanel, setActivePanel] = useState("panel1");

    // useEffect(() => {
    //     collapseRef1.current.classList.add("show");
    //     buttonRef1.current.setAttribute("aria-expanded", "true");
    //     collapseRef2.current.classList.remove("show");
    //     buttonRef2.current.setAttribute("aria-expanded", "false");
    // }, [dashboardResetFlag]);

    useEffect(() => {
        setActivePanel("panel1");
    }, [dashboardResetFlag]);

    const togglePanel = panel => {
        if (activePanel === panel) {
            // If the clicked panel is already active, collapse both panels (set activePanel to null)
            setActivePanel(null);
        } else {
            // If a different panel is clicked, expand that panel and collapse the other one
            setActivePanel(panel);
        }
    };

    // useEffect(() => {
    //     // Directly toggle the class when activePanel changes
    //     handlePanelToggle();
    // }, [activePanel]);

    // const handlePanelToggle = () => {
    //     // If no panel is active, remove the "show" class from both panels
    //     if (activePanel === null) {
    //         collapseRef1.current.classList.remove("show");
    //         collapseRef2.current.classList.remove("show");
    //         buttonRef1.current.setAttribute("aria-expanded", "false");
    //         buttonRef2.current.setAttribute("aria-expanded", "false");
    //     } else {
    //         // If there is an active panel, toggle only the corresponding panel
    //         collapseRef1.current.classList.remove("show");
    //         collapseRef2.current.classList.remove("show");
    //         buttonRef1.current.setAttribute("aria-expanded", "false");
    //         buttonRef2.current.setAttribute("aria-expanded", "false");

    //         // Add the "show" class to the active panel only
    //         if (activePanel === "panel1") {
    //             collapseRef1.current.classList.add("show");
    //             buttonRef1.current.setAttribute("aria-expanded", "true");
    //         } else if (activePanel === "panel2") {
    //             collapseRef2.current.classList.add("show");
    //             buttonRef2.current.setAttribute("aria-expanded", "true");
    //         }
    //     }
    // };

    // useEffect(() => {
    //     const handlePanelToggle = () => {
    //         collapseRef1.current.classList.remove("show");
    //         collapseRef2.current.classList.remove("show");
    //         buttonRef1.current.setAttribute("aria-expanded", "false");
    //         buttonRef2.current.setAttribute("aria-expanded", "false");

    //         setTimeout(() => {
    //             if (activePanel === "panel1") {
    //                 collapseRef1.current.classList.add("show");
    //                 buttonRef1.current.setAttribute("aria-expanded", "true");
    //             } else if (activePanel === "panel2") {
    //                 collapseRef2.current.classList.add("show");
    //                 buttonRef2.current.setAttribute("aria-expanded", "true");
    //             }
    //         }, 300);
    //     };

    //     handlePanelToggle();
    // }, [activePanel]);

    // useEffect(() => {
    //     const observer = new MutationObserver(handleCollapseClassChange);
    //     if (collapseRef1.current) {
    //         observer.observe(collapseRef1.current, { attributes: true });
    //     }
    //     return () => {
    //         observer.disconnect();
    //     };
    // }, []);

    useEffect(() => {
        ReactTooltip.rebuild();
    }, [props?.sidePanelValues, props?.activeBuildingType]);

    // const handleCollapseClassChange = mutationsList => {
    //     for (let mutation of mutationsList) {
    //         if (mutation.attributeName === "class") {
    //             const isCollapseVisible = collapseRef1.current.classList.contains("show");
    //             setStatExpanded(isCollapseVisible);
    //         }
    //     }
    // };

    const isBothCollapsed = activePanel === null;

    const {
        sidePanelValues,
        filterValues,
        activeSection,
        activeBuildingType,
        handleBuildingView,
        handleRecommentationView,
        handleRegionView,
        handleAdditionsView,
        handleSiteView,
        handleView,
        handleBuildingType,
        clearBuildingFilter,
        handleCapitalRequestView,
        handleFloorsView,
        isAssetDashboardView = false,
        isMobileAssetDashboardView = false,
        handleAssetsView,
        handleClientView
    } = props;

    const assetClient = (localStorage.getItem("asset_management_client") && JSON.parse(localStorage.getItem("asset_management_client"))) || {};
    let disableButton = isAssetDashboardView
        ? !(sidePanelValues?.client_ids || assetClient?.id) && !checkPermission("menu", "asset_management", null)
        : !(sidePanelValues?.project_ids?.length === 1);
    return (
        <div id="sidePanelAccordion">
            <div className="dash-side">
                <ReactTooltip id="filter-icons" />
                <div className="bld-brk">
                    <div className="table-sec">
                        <div className="head" id="sidePanelHeadingOne">
                            <h2
                                ref={buttonRef1}
                                className="d-flex hed-cls"
                                data-toggle="collapse"
                                data-target="#sidePanelCollapseOne"
                                aria-expanded={activePanel === "panel1"}
                                aria-controls="sidePanelCollapseOne"
                                onClick={() => togglePanel("panel1")}
                            >
                                Building Statistics
                            </h2>
                        </div>

                        <div
                            id="sidePanelCollapseOne"
                            ref={collapseRef1}
                            class={`collapse ${activePanel === "panel1" ? "show" : ""} `}
                            aria-labelledby="sidePanelHeadingOne"
                        >
                            <BuildingStatistics
                                sidePanelValues={sidePanelValues}
                                disableButton={disableButton}
                                activeSection={activeSection}
                                handleBuildingView={handleBuildingView}
                                handleRecommentationView={handleRecommentationView}
                                handleRegionView={handleRegionView}
                                handleSiteView={handleSiteView}
                                handleView={handleView}
                                handleAdditionsView={handleAdditionsView}
                                handleCapitalRequestView={handleCapitalRequestView}
                                capitalRequestLabel={capitalRequestLabel}
                                handleFloorsView={handleFloorsView}
                                isAssetDashboardView={isAssetDashboardView}
                                isMobileAssetDashboardView={isMobileAssetDashboardView}
                                handleAssetsView={handleAssetsView}
                                handleClientView={handleClientView}
                            />
                        </div>
                    </div>
                </div>
                <div className={`${!_.isEmpty(filterValues) ? "scrol-side" : ""} ${statExpanded ? "" : "collapse-hide"} bld-brk`}>
                    <div className="table-sec">
                        <div className="head" id="sidePanelHeadingTwo">
                            <h2
                                ref={buttonRef2}
                                className="d-flex hed-cls"
                                data-toggle="collapse"
                                data-target="#sidePanelCollapseTwo"
                                aria-expanded={activePanel === "panel2"}
                                aria-controls="sidePanelCollapseTwo"
                                onClick={() => togglePanel("panel2")}
                            >
                                Building Breakdown ({sidePanelValues ? sidePanelValues.buildings : 0})
                            </h2>
                        </div>
                        <div
                            id="sidePanelCollapseTwo"
                            ref={collapseRef2}
                            class={`collapse ${activePanel === "panel2" ? "show" : ""}`}
                            aria-labelledby="sidePanelHeadingTwo"
                        >
                            <BuildingBreakdown
                                activeBuildingType={activeBuildingType}
                                activeSection={activeSection}
                                disableButton={disableButton}
                                sidePanelValues={sidePanelValues}
                                handleBuildingType={handleBuildingType}
                                clearBuildingFilter={clearBuildingFilter}
                                isBuildAccordian={activePanel === "panel2"}
                            />
                        </div>
                    </div>
                </div>
                {!_.isEmpty(filterValues) && (
                    <div className={`tag-ara ${isBothCollapsed ? "acco-close" : ""}`}>
                        <div className={"tag-scrol"}>
                            {Object.values(filterValues).map(f => {
                                return f.name !== "Years" ? (
                                    f?.value?.length > 0 && (
                                        <>
                                            <span className={`tag active ${f.name === "Project Cost" ? "red" : ""}`}>{f.name} </span>
                                            {f.value.map(item => {
                                                return (
                                                    <span key={item} className="tag">
                                                        {item}
                                                    </span>
                                                );
                                            })}
                                            <br />
                                        </>
                                    )
                                ) : (
                                    <>
                                        <span className="tag active">{f.name} </span>
                                        <span className="tag">Start : {f.value.start}</span>
                                        <span className="tag">End : {f.value.end}</span>
                                    </>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
const mapStateToProps = state => {
    const { dashboardReducer } = state;
    return { dashboardReducer };
};
export default withRouter(
    connect(mapStateToProps, {
        ...dashboardAction
    })(SidePanel)
);
